import { addCommas, addCommasWithoutDecimal, } from "@domains/utils/numberMethods";
import React, { useEffect, useState } from "react";
import _ from "underscore";
export var StreamValType;
(function (StreamValType) {
    StreamValType["EMPTY"] = "empty-val";
    StreamValType["RED"] = "change-red";
    StreamValType["GREEN"] = "change-green";
})(StreamValType || (StreamValType = {}));
const ReportValue = (props) => {
    const [val, setVal] = useState(props === null || props === void 0 ? void 0 : props.val);
    const [streamClass, setStreamClass] = useState();
    useEffect(() => {
        const newVal = props.hideDecimal === true
            ? addCommasWithoutDecimal(props === null || props === void 0 ? void 0 : props.val, props === null || props === void 0 ? void 0 : props.showZero, "", props === null || props === void 0 ? void 0 : props.maximumFractionDigits)
            : addCommas(props === null || props === void 0 ? void 0 : props.val, props === null || props === void 0 ? void 0 : props.showZero, "", props === null || props === void 0 ? void 0 : props.maximumFractionDigits);
        if (newVal === "-") {
            setStreamClass(StreamValType.EMPTY);
        }
        else {
            if (newVal === null || newVal === void 0 ? void 0 : newVal.toString().includes("-")) {
                setStreamClass(StreamValType.RED);
            }
            else {
                setStreamClass(StreamValType.GREEN);
            }
        }
        setVal(newVal);
    }, [props.val]);
    if (props.stream) {
        return (React.createElement("span", { className: `${props.parentClass} ${streamClass}` },
            props.percentage &&
                streamClass !== StreamValType.EMPTY &&
                !props.notRoundBracket &&
                "(",
            props.suffix && props.suffix,
            !props.issuffixhide
                ? streamClass === StreamValType.GREEN
                    ? "+"
                    : ""
                : streamClass === StreamValType.GREEN && "",
            props.defaultReturn && streamClass === StreamValType.EMPTY
                ? props.defaultReturn
                : val,
            props.percentage && streamClass !== StreamValType.EMPTY && "%",
            val !== "-" && props.percentage && !props.notRoundBracket && ")",
            props.prefix && props.prefix));
    }
    else if (props.onlyval)
        return (React.createElement(React.Fragment, null,
            props.suffix && props.suffix,
            props.defaultReturn && streamClass === StreamValType.EMPTY
                ? props.defaultReturn
                : val,
            props.prefix && props.prefix));
    else
        return React.createElement("span", { className: props.parentClass }, val);
};
export default React.memo(ReportValue, (prevProps, NextProps) => _.isEqual(prevProps, NextProps));
